var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{directives:[{name:"resize",rawName:"v-resize",value:({ log: true }),expression:"{ log: true }"}],attrs:{"src":_vm.url,"frameborder":"0","id":"myiframe","width":"100%","allowtransparency":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }